module.exports = {"632623100":"柯曲镇","632623200":"上贡麻乡","632623201":"下贡麻乡","632623202":"岗龙乡","632623203":"青珍乡","632623204":"江千乡","632623205":"下藏科乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/632623.json
// module id = 3148
// module chunks = 0